<div mat-dialog-header>
  <h1>{{ dialogTitle }} - Change Comparison</h1>
</div>
<div mat-dialog-content class="dialog-content">
  <table>
    <thead>
      <th></th>
      @for (date of changeDates; track date; let i = $index) {
        <th>
          {{ date }}<br />
          Run Count: {{ runCounts[i] }}
        </th>
      }
    </thead>
    <tbody>
      @for (row of gridRows; track row) {
        @if (showRow(row)) {
          <tr>
            @if (row.IsHeader) {
              <td class="header" [attr.colspan]="row.Values.length + 1">
                <h2 class="mb-0">{{ row.fieldLabel }}</h2>
              </td>
            } @else {
              <td class="field-label">
                <strong>{{ row.fieldLabel || row.label }}</strong>
              </td>
              @if (row.Values) {
                @for (value of row.Values; track value; let i = $index) {
                  <td
                    [ngClass]="{
                      highlight: highlightRow(row, row.fieldName, i),
                    }"
                  >
                    @if (row.Display && row.DisplayMapping) {
                      {{ findDisplayValue(value, row) }}
                    } @else if (value === 'N/A') {
                      N/A
                    } @else if (row.Type) {
                      @switch (row.Type) {
                        @case ('integer') {
                          {{ value | number: '1.0-0' }}
                        }
                        @case ('curr') {
                          {{ value | currency }}
                        }
                        @case ('perc') {
                          {{ value | percent }}
                        }
                        @case ('perc2') {
                          {{ value | percent: '1.2' }}
                        }
                        @case ('date') {
                          {{ value | date: 'short' }}
                        }
                        @case ('shortDate') {
                          {{ value | date: 'shortDate' }}
                        }
                      }
                    } @else {
                      {{ value }}
                    }
                  </td>
                }
              } @else if (row.values) {
                @for (value of row.values; track value; let i = $index) {
                  <td
                    [ngClass]="{
                      highlight: highlightRow(row, row.variable, i),
                    }"
                  >
                    {{ value }}
                  </td>
                }
              }
            }
          </tr>
        }
      }
    </tbody>
  </table>

  <div
    class="mt-4"
    [matTooltip]="
      data.changeIDs.length !== 2
        ? 'Only available if 2 changes have been selected'
        : ''
    "
  >
    <button
      type="button"
      class="w-100"
      matButton="outlined"
      color="primary"
      [disabled]="data.changeIDs.length !== 2"
      (click)="toggleMoreData()"
    >
      {{ moreDataVisible ? 'Show Less Data' : 'Load More Data' }}
    </button>
  </div>
</div>
<div class="buttons">
  <button type="button" matButton="outlined" (click)="close()">Close</button>
</div>
